const ONBOARDING_SUPPRESSED_KEY = 'ae-onboarding-suppressed-v1';
const WALKTHROUGH_SUPPRESSED_KEY = 'ae-walkthrough-suppressed-v1';

export const ONBOARDING_STASH_KEY = 'ae-onboarding-stash';
export const ONBOARDING_PROGRESS_KEY = 'ae-onboarding-progress-v1';
export const ONBOARDING_ACCOUNT_CREATED_KEY = 'ae-onboarding-account-created';

function readBoolean(key: string): boolean {
    if (typeof window === 'undefined') return false;

    try {
        return window.localStorage.getItem(key) === 'true';
    } catch {
        return false;
    }
}

function writeBoolean(key: string, value: boolean): void {
    if (typeof window === 'undefined') return;

    try {
        if (value) {
            window.localStorage.setItem(key, 'true');
        } else {
            window.localStorage.removeItem(key);
        }
    } catch {
        // Best-effort persistence only.
    }
}

export function isOnboardingSuppressed(): boolean {
    return readBoolean(ONBOARDING_SUPPRESSED_KEY);
}

export function suppressOnboarding(): void {
    writeBoolean(ONBOARDING_SUPPRESSED_KEY, true);
}

export function clearOnboardingSuppression(): void {
    writeBoolean(ONBOARDING_SUPPRESSED_KEY, false);
}

export function hasActiveOnboardingProgress(): boolean {
    if (typeof window === 'undefined') return false;

    try {
        if (window.localStorage.getItem(ONBOARDING_ACCOUNT_CREATED_KEY) === 'true') return true;
        if (window.sessionStorage.getItem(ONBOARDING_STASH_KEY)) return true;

        const progress = window.localStorage.getItem(ONBOARDING_PROGRESS_KEY);
        if (!progress) return false;

        try {
            const parsed = JSON.parse(progress) as { step?: unknown };
            return typeof parsed.step === 'number' && parsed.step > 0;
        } catch {
            return true;
        }
    } catch {
        return false;
    }
}

export function isWalkthroughSuppressed(): boolean {
    return readBoolean(WALKTHROUGH_SUPPRESSED_KEY);
}

export function suppressWalkthrough(): void {
    writeBoolean(WALKTHROUGH_SUPPRESSED_KEY, true);
}

export function clearWalkthroughSuppression(): void {
    writeBoolean(WALKTHROUGH_SUPPRESSED_KEY, false);
}
